export default {
  // Tabs
  systemTemplate: '系统模板',
  myTemplate: '我的模板',
  // 操作
  customCreate: '自定义创建',
  // 空状态
  emptyMyTemplate: '暂无自定义模板',
  emptyCanvas: '拖拽组件到此处',
  selectComponentTip: '点击画布中的组件进行编辑',
  // 编辑器
  componentLibrary: '组件库',
  propertyPanel: '属性配置',
  publicConfig: '公共配置',
  langConfig: '当前语言配置',
  templateManager: '模板管理',
  newTemplate: '新建模板',
  cloneTemplate: '复制模板',
  deleteTemplate: '删除模板',
  templateName: '模板名称',
  templateType: '模板类型',
  supportedLangs: '支持语言',
  // 页面配置
  pageConfig: '页面配置',
  pageTitle: '页面标题',
  pageTitlePlaceholder: '请输入页面标题',
  canvasConfig: '画布配置',
  bgColor: '背景色',
  padding: '边距',
  styleConfig: '样式配置',
  noStyleConfig: '该组件暂无样式配置',
  // 组件名称
  component_carousel: '轮播图',
  component_productInfo: '产品信息',
  component_antiFake: '防伪信息',
  component_traceability: '溯源信息',
  component_imageGrid: '图片橱窗',
  component_spacer: '空白条',
  component_activityPopup: '活动弹窗',
  component_videoPlayer: '视频',
  component_bottomMenu: '底部菜单',
  // 同步语言
  syncLang: '同步配置',
  syncLangTitle: '同步配置到其他语言',
  syncLangDesc: '将当前语言（{lang}）的模板配置同步到以下选中的语言，目标语言的原有配置将被覆盖。',
  syncLangSuccess: '同步配置成功',
};
